<header class="topbar">
  <div>
    <h1>{{ title() }}</h1>
    <p class="topbar__subtitle">{{ subtitle() }}</p>
  </div>
  <div class="topbar__navigation">
    <div class="topbar__icons">
      <div class="topbar__notifications">
        <div
          pBadge
          class="topbar__notify"
          [severity]="notifyCount() ? 'danger' : 'info'"
          [value]="notifyCount()"
          (click)="showNotifyClicked.emit()">
          <i
            class="topbar__icon pi pi-bell"
            tooltipPosition="left"
            [pTooltip]="tooltipLabel()"></i>
        </div>
      </div>
      <i class="topbar__icon pi pi-cog" (click)="editCompanyClicked.emit()"></i>
    </div>

    <button pButton pRipple class="action" (click)="createOrderClicked.emit()">
      <i class="topbar__icon--small pi pi-plus"></i>
      <span>New order</span>
    </button>
  </div>
</header>
